import { render } from "./TestimonialMx.vue?vue&type=template&id=d04f5b02&scoped=true"
import script from "./TestimonialMx.vue?vue&type=script&lang=js"
export * from "./TestimonialMx.vue?vue&type=script&lang=js"

import "./TestimonialMx.vue?vue&type=style&index=0&id=d04f5b02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d04f5b02"]])

export default __exports__